"use strict";

exports.__esModule = true;
exports.EditDevicesSection = EditDevicesSection;
var _react = _interopRequireDefault(require("react"));
var _FormGroupField = require("../../Form/FormGroupField");
var _DeviceSelector = require("../../Device/DeviceSelector");
var _DetailsComponent = require("../../Core/DetailsComponent");
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function EditDevicesSection(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var deviceList = props.deviceList,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style;
  function validateDevices(value) {
    if (!Array.isArray(value) || value.length === 0) {
      return translate("TicketDetailsEditForm.deviceError", "Device is required.");
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
    heading: translate("TicketDetailsEditForm.devicesLabel", "Devices"),
    content: /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "devices",
      validate: validateDevices,
      style: style
    }, function (_ref) {
      var input = _ref.input;
      return /*#__PURE__*/_react["default"].createElement(_DeviceSelector.DeviceSelector, {
        usePortal: false,
        minimal: true,
        items: deviceList,
        selected: input.value,
        onSelect: input.onChange,
        multiple: true
      });
    })
  });
}